import React, { FC } from 'react'
import { Col, Row } from 'antd'
import Icon from '../../../../components/Icon'

type Props = {
  label: string
  template: string
}

const LabelWithTemplate: FC<Props> = ({ label, template }) => {
  return (
    <Row className='w-100' justify='space-between' align='middle'>
      <Col className='pr-8'>
        <a href={template}>
          <Icon icon='file-arrow-down' />
        </a>
      </Col>
      <Col>
        <span>{label}</span>
      </Col>
    </Row>
  )
}

export default LabelWithTemplate
